import { render, staticRenderFns } from "./ConfigureEntityField.vue?vue&type=template&id=4347aedc&scoped=true"
import script from "./ConfigureEntityField.vue?vue&type=script&lang=js"
export * from "./ConfigureEntityField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureEntityField.vue?vue&type=style&index=0&id=4347aedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347aedc",
  null
  
)

export default component.exports